export interface DocumentsState {
  isLoadingRequiredDocs: boolean;
  sentAllRequiredDocs: boolean;
}

const state: DocumentsState = {
  isLoadingRequiredDocs: true,
  sentAllRequiredDocs: false,
};

export default state;
